const Form = () => {
  const signup = document.querySelector('.signup');
  const formContainer = document.querySelector('.signup__form');
  const formSignup = document.querySelector('#signup');
  const formInputControls = document.querySelectorAll('.form-input__control-text');
  const formSelectButtons = document.querySelectorAll('.form-input__control-select');
  const formSelectDropdown = document.querySelectorAll('.select-dropdown__list');
  const formSubmitButton = document.querySelector('.form-button--submit');
  const formAgreeCheckbox = document.querySelector('[name=agreeField]');
  const formMobileTooltip = document.querySelector('.js-sms-tooltip');
  const formMobileTooltipClose = document.querySelector('.js-sms-tooltip-close');

  const formData = {
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    title: '',
    company: '',
    '00N1U00000VZOE9': '',
    industry: '',
  };

  const confirmFields = ['email_confirm', 'mobile_confirm'];

  if (! signup) {
    return false;
  }

  onInit();

  if (! formContainer) {
    return false;
  }

  if (formMobileTooltip) {
    formMobileTooltip.addEventListener('click', e => {
      e.preventDefault();
      if (window.innerWidth < 1024) {
        document.querySelector('.sms-help').classList.add('is-visible');
      }
    });

    formMobileTooltipClose.addEventListener('click', e => {
      e.preventDefault();
      document.querySelector('.sms-help').classList.remove('is-visible');
    });
  }

  formSubmitButton.addEventListener('click', function(e) {
    e.preventDefault();

    // eslint-disable-next-line no-undef
    ga(function() {
      const tracker = ga.getAll()[ 0 ];
      const clientId = tracker.get('clientId');
      document.getElementById('00N1U00000VZOE5').value = clientId;
    });

    setTimeout(() => {
      if (checkValidForm()) {
        if (! formAgreeCheckbox.checked) {
          formAgreeCheckbox.setAttribute('style', 'outline: 1px solid red');
          return false;
        }

        formSignup.submit();
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (! formAgreeCheckbox.checked) {
          formAgreeCheckbox.setAttribute('style', 'outline: 1px solid red');
        }
        return false;
      }
    }, 250);
  });

  formSelectDropdown.forEach(dropdown => {
    dropdown.addEventListener('click', onSelectOption);
    dropdown.addEventListener('focus', onSelectListFocus);
  });

  formInputControls.forEach(control => {
    control.addEventListener('focus', onFocus);
    control.addEventListener('blur', onBlur);
  });

  formSelectButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();

      const target = e.target;
      const targetParent = target.closest('.form-input');

      if (! targetParent.classList.contains('select-is-open')) {
        openSelectList(e);
      } else {
        closeSelectList(target);
      }
    });
  });

  formAgreeCheckbox.addEventListener('click', e => {
    if (e.target.checked) {
      formAgreeCheckbox.setAttribute('style', '');
    }
  });

  function onInit() {
    const menu = document.querySelector('.menu');
    const footer = document.querySelector('.footer');

    menu.setAttribute('style', 'display: none');
    footer.setAttribute('style', 'display: none');
  }

  function onFocus(e) {
    e.target.parentNode.classList.add('has-focus');
  }

  function onBlur(e) {
    e.target.parentNode.classList.remove('has-focus');

    checkValue(e);
  }

  function checkValidForm() {
    const formInputs = Array.from(document.querySelectorAll('.form-input'));
    const hasError = document.querySelectorAll('.has-error');
    let isFormValid = false;

    if (! formInputs.every(input => input.classList.contains('has-value')) || hasError.length !== 0) {
      formContainer.classList.add('form-has-error');
      isFormValid = false;

      // check values of formaData
      for (const key in formData) {
        if (formData[ key ] === '') {
          const el = document.querySelector(`input[id='${ key }']`) || document.querySelector(`button[id='${ key }']`);
          el.parentNode.classList.add('has-error');
        }
      }

      // check values of confirmation fields
      confirmFields.forEach(input => {
        const el = document.querySelector(`input[name='${ input }']`);
        if (el.value === '') {
          el.parentNode.classList.add('has-error');
        }
      });
    } else {
      formContainer.classList.remove('form-has-error');
      isFormValid = true;
    }

    return isFormValid;
  }

  function checkValue(e) {
    const target = e.target || e;
    const formInput = target.closest('.form-input');
    const { name, type, value } = target;

    if (name !== 'email_confirm' && name !== 'mobile_confirm') {
      setValue(name, value);
    }

    if (formData[ `${ name }` ] !== '' && value !== '') {
      formInput.classList.add('has-value');

      // If Fields are Email or Mobile,
      // reset values of its corresponding confirm fields
      if (name === 'email' || name === 'mobile') {
        const confirmField = document.querySelector(`[name='${ name }_confirm']`);
        confirmField.closest('.form-input').classList.remove('has-value');
        confirmField.value = '';
      }

      // If Field is Email,
      // check if it's valid
      if (type === 'email' && ! checkValidEmail(value)) {
        formInput.classList.add('has-error');
        return false;
      }

      // If Fields are Email or Mobile confirmations,
      // check corresponding fields for value match
      if (
        (name === 'email_confirm' && ! checkConfirmMatch('email', value)) ||
        (name === 'mobile_confirm' && ! checkConfirmMatch('mobile', value))
      ) {
        formInput.classList.add('has-error');
        return false;
      }

      formInput.classList.remove('has-error');
    } else {
      formInput.classList.remove('has-focus');
      formInput.classList.remove('has-value');
      formInput.classList.add('has-error');
    }
  }

  function checkConfirmMatch(fieldToCheck, value) {
    return value === formData[ fieldToCheck ];
  }

  function checkValidEmail(data) {
    const pattern = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g);
    var isValidEmail = pattern.test(data);
    
    if(isValidEmail === true) {
      const pattern2 = /gmail\.com|yahoo\.com|hotmail\.com|\.edu|msn\.com|aol\.com|outlook\.com/;
      const pattern3 = /fox\.com|bcl\.xyz|foxsports\.net|foxnews\.com|tubi\.tv/;
      var isBlacklistEmail = pattern2.test(data);
      var isEmployeeEmail = pattern3.test(data);
      if(isBlacklistEmail === true) {
        isValidEmail = false;
        jQuery('#email-validation-text').addClass('active');
        jQuery('#email-validation-text').html('Thanks for your interest in an account with FOX Ad Solutions. The information you provided does not meet the qualifications to register for an account. Please register using your company email address.');
      } else if(isEmployeeEmail === true) {
        isValidEmail = false;
        jQuery('#email-validation-text').addClass('active');
        jQuery('#email-validation-text').html('Great news! FOX Ad Sales employees can sign in to FOX Ad Solutions through Okta.<br><br>To sign in, return to the log in screen and click "For FOX Employees" OR visit your My FOX Okta Apps dashboard and click the FOX Ad Solutions app. You will be prompted to enter your Okta login credentials.<br><br>If you still have trouble signing in, please request access through the FOXHelpBot in Slack for assistance.<br><br>Thank you\,<br>FOX Ad Sales Portal Team');
     } else {
        jQuery('#email-validation-text').removeClass('active');
        jQuery('#email-validation-text').text('');
      }
    }
    return isValidEmail;
  }

  function openSelectList(e) {
    const target = e.target;

    jQuery('.select-is-open').removeClass('select-is-open'); // eslint-disable-line no-undef

    target.closest('.form-input').classList.add('select-is-open');
    target.setAttribute('aria-expanded', 'true');

    // Move focus to the select dropdown list
    target.nextElementSibling.focus();

    // Close select dropdown link on `esc` key
    document.addEventListener('keydown', function(event) {
      switch (event.keyCode) {
      case 27: //esc
        closeSelectList(target);
        break;
      }
    });
  }

  function closeSelectList(target) {
    target.closest('.form-input').classList.remove('select-is-open');
    target.setAttribute('aria-expanded', 'false');

    checkValue(target);
  }

  function onSelectOption(e) {
    const target = e.target;
    const parent = e.currentTarget.parentNode;
    const inputName = parent.querySelector('.form-input__control-select').name;

    // On selection of an option,
    // update text value of button,
    // update aria-selected value of selected option
    // close dropdown list
    if (e.target.classList.contains('select-dropdown__list-option')) {
      const selectedValue = e.target.innerHTML.toString();
      parent.querySelector('.form-input__control-select').innerHTML = e.target.innerHTML;
      parent.querySelector('.form-input__control-select').setAttribute('aria-expanded', 'false');
      parent.classList.remove('has-error');

      target.parentNode.querySelector('li[aria-selected=true]').removeAttribute('aria-selected');
      target.setAttribute('aria-selected', 'true');

      // set input[hidden] value
      document.querySelector(`input[ name="${ inputName }" ]`).value = e.target.innerHTML;

      // set value in formData object
      setValue(inputName, e.target.innerHTML);
      if (selectedValue.includes('Agency') || selectedValue.includes('agency')) {
        document.querySelector(`input[ name="industry" ]`).value = 'Agency';
        document.querySelector('#industry').innerHTML = 'Agency';
        document.querySelector('#industry').parentElement.classList.add('has-value');
        setValue('industry', 'Agency');
      }

      closeSelectList(e.target);
    }
  }

  function onSelectListFocus(e) {
    const target = e.target;

    // On focus of select dropdown list
    // Move focus to first option if no current selection
    if (target.querySelector('li[aria-selected=true]') === null) {
      target.querySelector('li').setAttribute('aria-selected', 'true');
      target.querySelector('li').focus();
    } else {
      target.querySelector('li[aria-selected=true]').focus();
    }
  }

  function setValue(name, value) {
    formData[ name ] = value;
  }
};

export default Form;
